export const business = {
  name: 'Goelst International B.V.',
  shortName: 'Goelst International',
  tagline: 'European Quality & Design',
  category: 'Gordijnrails',
  kvk: '62012592',
  since: '1978',
  website: 'https://goelst-international.com/',
  websiteLabel: 'goelst-international.com',
  email: 'info@goelst-international.com',
  phoneDisplay: '0031 (0)33 303 5964',
  phoneLink: '+31333035964',
  instagram: 'https://www.instagram.com/goelst_international/',
  instagramLabel: '@goelst_international',
  address: {
    street: 'Modemweg 19',
    postalCode: '3821 BS',
    city: 'Amersfoort',
    region: 'Utrecht',
    country: 'Nederland',
  },
  mapsLink:
    'https://www.google.com/maps/search/?api=1&query=Modemweg+19%2C+3821+BS+Amersfoort%2C+Nederland',
  mapsEmbed:
    'https://www.google.com/maps?q=Modemweg%2019,%203821%20BS%20Amersfoort,%20Nederland&output=embed',
  hours: [
    { day: 'Maandag', time: '09:00 – 18:00', open: true },
    { day: 'Dinsdag', time: '09:00 – 18:00', open: true },
    { day: 'Woensdag', time: '09:00 – 18:00', open: true },
    { day: 'Donderdag', time: '09:00 – 18:00', open: true },
    { day: 'Vrijdag', time: '09:00 – 18:00', open: true },
    { day: 'Zaterdag', time: 'Gesloten', open: false },
    { day: 'Zondag', time: 'Gesloten', open: false },
  ],
}

export const images = {
  logo: 'https://cdn.magicpatterns.com/uploads/x8vLnVD3YoYc8XE48QnjiF/aaLogo.jpg',
  interiorTallWindow: 'https://cdn.magicpatterns.com/uploads/t8TZhEJHD5sJSjJjKQgnsh/Screenshot_2.jpg',
  railProfile: 'https://cdn.magicpatterns.com/uploads/biAfzRRHngvWd8v7kgz7Ha/Screenshot_3.jpg',
  railMulti: 'https://cdn.magicpatterns.com/uploads/2xzvaJKbSNUjExHxx2oKQT/Screenshot_4.jpg',
  interiorBeige: 'https://cdn.magicpatterns.com/uploads/asBiHnUZyoBw8bS3wWeLX4/Screenshot_5.jpg',
  interiorSeaView: 'https://cdn.magicpatterns.com/uploads/sfHbzcgNiUkgAzqA5zTPwS/Screenshot_6.jpg',
  railMotor: 'https://cdn.magicpatterns.com/uploads/4A113rKsUnn9C3g3D9pM1U/Screenshot_7.jpg',
  interiorSheer: 'https://cdn.magicpatterns.com/uploads/hbQr7HPktAPWv6b9yM5DKn/Screenshot_8.jpg',
}
